export default __webpack_public_path__ + "static/bannerLeathergoods-30d1ffdf8c06c02811ae9529488e260c.jpg";